export const isOneWayFlightSearch = (value) => value === 'true' || value === true;

export const getFlightSearchReturnDate = (params) => {
  const isOnlyOneWay = isOneWayFlightSearch(params?.isOnlyOneWay);
  return isOnlyOneWay ? null : params?.returnDate;
};

export const buildLlegoPayload = ({ params, filters, cache, delegation, currency }) => ({
  originId: params.originId,
  destinationID: params.destinationId,
  origin: params.originName,
  destination: params.destinationName,
  passengers: params.passengers,
  departureDate: params.departureDate,
  returnDate: getFlightSearchReturnDate(params),
  direct: false,
  baggage: false,
  cabin: filters.cabinClass,
  currency,
  cache,
  delegation,
});
